const ERROR_MESSAGES = {
    ERROR_NO_LEVEL_ACCESS: 'No Access',
    ERROR_NO_ACCOUNT_ACCESS: 'No Access to account',
    ERROR_INVALID_LEVEL: 'Invalid Level Selected',
    ERROR_MISSING_REQUIRED_FIELD: 'This field is required',
    ERROR_INVALID_DELIVERY_FREQUENCY: 'Invalid Delivery Selected',
    ERROR_MISSING_SUBJECT:'Subject field is required',
    ERROR_MISSING_EXPORT_NAME: 'Export name is required',
    ERROR_INVALID_DATE_RANGE:'Select an appropriate value',
    ERROR_INVALID_EXPORT_FILE_TYPE :'Invalid Export File',
    ERROR_INVALID_GROUP_DATA_BY_TIME:'Invalid Group Data',
    ERROR_MIN_RECIPIENTS:'You must specify at least one recipients',
    ERROR_MAX_RECIPIENTS:'Recipients can not be more than 15',
    ERROR_INVALID_COMMISSION:'Invalid Commission Value',
    ERROR_INVALID_EXPORT_METHOD:'Invalid Export Type',
    ERROR_INVALID_TIME_ZONE:'Invalid Time Zone',
    ERROR_NO_DELIVERY_ACCESS:'Invalid Delivery Access',
    ERROR_REPORT_ID:"Invalid Report Id",
    ERROR_NO_WHITELABEL_ACCESS:"No Access",
    ERROR_MISSING_ACCOUNT:'Invalid Account Id',
    ERROR_MISSING_REPORT_ID:'Invalid Report Id',
    ERROR_INVALID_CUSTOM_START_DATE:'Invalid Start Date',
    ERROR_INVALID_CUSTOM_END_DATE:'Invalid End Date',
    ERROR_INVALID_PERIOD_LENGTH:'Invalid Period Length',
    ERROR_INVALID_EMAIL:'Invalid Email Address',
    ERROR_BILLING_PERIOD_VALUE: "Select Billing Period"

  };
  
  export default ERROR_MESSAGES;
